import React from 'react';
import Sidebar from './Sidebar';
import { useAuth } from '../../context/AuthContext';
import ForcePasswordChange from '../common/ForcePasswordChange';

export default function DashboardLayout({ children, sidebarItems, title }) {
  const { user } = useAuth();
  return (
    <div className="sms-layout">
      <Sidebar items={sidebarItems} title={title} />
      <div className="sms-main">
        <div className="sms-content">{children}</div>
      </div>
      {user?.must_change_password && <ForcePasswordChange />}
    </div>
  );
}
